module.exports = __webpack_public_path__ + "static/media/18ECA32.ab4a7a40.jpg";